import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  data: {},
  storageUsage: {},
  listeningTimeGraph: [],
  userGrowthGraph: [],
  topTracks: [],
  listeningPerUser: [],
  conversionRateGraph: [],
  loading: false,
  error: null
};

/* ================== THUNKS ================== */

// export const fetchDashboardData = createAsyncThunk(
//   'dashboard/fetch',
//   async (params = {}, { rejectWithValue }) => {
//     try {
//       const getDateParams = (range = {}) => ({
//         ...(range.start_date ? { start_date: range.start_date } : {}),
//         ...(range.end_date ? { end_date: range.end_date } : {}),
//       });

//       const dashboardDateParams = getDateParams(params.dashboard || params.conversion || params);
//       const listeningTimeDateParams = getDateParams(params.listeningTime || params);
//       const userGrowthDateParams = getDateParams(params.userGrowth || params);

//       const hasDashboardDateParams = Object.keys(dashboardDateParams).length > 0;
//       const hasListeningTimeDateParams = Object.keys(listeningTimeDateParams).length > 0;
//       const hasUserGrowthDateParams = Object.keys(userGrowthDateParams).length > 0;

//       const dashboardRequestConfig = {
//         ...(hasDashboardDateParams ? { params: dashboardDateParams } : {}),
//       };
//       const listeningTimeRequestConfig = {
//         ...(hasListeningTimeDateParams ? { params: listeningTimeDateParams } : {}),
//       };
//       const userGrowthRequestConfig = {
//         ...(hasUserGrowthDateParams ? { params: userGrowthDateParams } : {}),
//       };

//       const [
//         dashboardResponse,
//         storageUsageResponse,
//         listeningTimeResponse,
//         userGrowthResponse,
//         topTracksResponse,
//         listeningPerUserResponse,
//       ] = await Promise.all([
//         axiosInstance.get('/api/admin/dashboard', dashboardRequestConfig),
//         axiosInstance.get('/api/admin/dashboard/storage-usage'),
//         axiosInstance.get('/api/admin/dashboard/graphs/listening-time', listeningTimeRequestConfig),
//         axiosInstance.get('/api/admin/dashboard/graphs/user-growth', userGrowthRequestConfig),
//         axiosInstance.get('/api/admin/dashboard/insights/top-tracks', dashboardRequestConfig),
//         axiosInstance.get('/api/admin/dashboard/insights/listening-per-user', dashboardRequestConfig),
//       ]);

//       return {
//         data: dashboardResponse.data?.data || dashboardResponse.data || {},
//         storageUsage: storageUsageResponse.data?.data || storageUsageResponse.data || {},
//         listeningTimeGraph: listeningTimeResponse.data?.data || listeningTimeResponse.data || [],
//         userGrowthGraph: userGrowthResponse.data?.data || userGrowthResponse.data || [],
//         topTracks: topTracksResponse.data?.data || topTracksResponse.data || [],
//         listeningPerUser: listeningPerUserResponse.data?.data || listeningPerUserResponse.data || [],
//       };
//     } catch (err) {
//       return rejectWithValue(err.response?.data?.message || 'Failed to fetch dashboard data');
//     }
//   }
// );

export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetch',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = {};
      if (params.dashboard || params.conversion) {
        const res = await axiosInstance.get('/api/admin/dashboard', {
          params: params.dashboard || params.conversion,
        });

        response.data = res.data?.data || {};
      }

      if (params.listeningTime) {
        const res = await axiosInstance.get(
          '/api/admin/dashboard/graphs/listening-time',
          { params: params.listeningTime }
        );

        response.listeningTimeGraph = res.data?.data || [];
      }
      if (params.conversion) {
        const res = await axiosInstance.get(
          '/api/admin/dashboard/graphs/conversion-rate',
          { params: params.conversion }
        );

        response.conversionRateGraph = res.data?.data || [];
      }

      if (params.userGrowth) {
        const res = await axiosInstance.get(
          '/api/admin/dashboard/graphs/user-growth',
          { params: params.userGrowth }
        );

        response.userGrowthGraph = res.data?.data || [];
      }

      if (Object.keys(params).length === 0) {
        const [
          dashboardRes,
          storageRes,
          listeningRes,
          userGrowthRes,
          conversionRes,
          topTracksRes,
          listeningUserRes,
        ] = await Promise.all([
          axiosInstance.get('/api/admin/dashboard'),
          axiosInstance.get('/api/admin/dashboard/storage-usage'),
          axiosInstance.get('/api/admin/dashboard/graphs/listening-time'),
          axiosInstance.get('/api/admin/dashboard/graphs/user-growth'),
          axiosInstance.get('/api/admin/dashboard/graphs/conversion-rate'),
          axiosInstance.get('/api/admin/dashboard/insights/top-tracks'),
          axiosInstance.get('/api/admin/dashboard/insights/listening-per-user'),
        ]);

        response.data = dashboardRes.data?.data || {};
        response.storageUsage = storageRes.data?.data || {};
        response.listeningTimeGraph = listeningRes.data?.data || [];
        response.userGrowthGraph = userGrowthRes.data?.data || [];
        response.conversionRateGraph = conversionRes.data?.data || [];
        response.topTracks = topTracksRes.data?.data || [];
        response.listeningPerUser = listeningUserRes.data?.data || [];
      }

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Failed to fetch dashboard data'
      );
    }
  }
);
/* ================== SLICE ================== */

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // .addCase(fetchDashboardData.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.data = action.payload.data;
      //   state.storageUsage = action.payload.storageUsage;
      //   state.listeningTimeGraph = action.payload.listeningTimeGraph;
      //   state.userGrowthGraph = action.payload.userGrowthGraph;
      //   state.topTracks = action.payload.topTracks;
      //   state.listeningPerUser = action.payload.listeningPerUser;
      // })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload;

        
        if (payload.data && Object.keys(payload.data).length) {
          state.data = payload.data;
        }

        if (payload.storageUsage && Object.keys(payload.storageUsage).length) {
          state.storageUsage = payload.storageUsage;
        }

        if (payload.listeningTimeGraph) {
          state.listeningTimeGraph = payload.listeningTimeGraph;
        }

        if (payload.userGrowthGraph) {
          state.userGrowthGraph = payload.userGrowthGraph;
        }

        if (payload.topTracks) {
          state.topTracks = payload.topTracks;
        }
        if (payload.conversionRateGraph) {
          state.conversionRateGraph = payload.conversionRateGraph;
        }

        if (payload.listeningPerUser) {
          state.listeningPerUser = payload.listeningPerUser;
        }
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  }
});

export default dashboardSlice.reducer;
